// src/firebaseConfig.js (PARA LA APLICACIÓN DEL PERSONAL)
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth'; // Para autenticación
import { getFirestore } from 'firebase/firestore'; // Para Cloud Firestore
import { getStorage } from 'firebase/storage'; // Para Cloud Storage

const firebaseConfig = {
  apiKey: "AIzaSyD09zdY2XQTSOPw1h0CSULpVgC4YIOjPSs",
  authDomain: "clinicajure.firebaseapp.com",
  projectId: "clinicajure",
  storageBucket: "clinicajure.firebasestorage.app",
  messagingSenderId: "944673196450",
  appId: "1:944673196450:web:c267c9cfbe27a559380afb",
  measurementId: "G-RKJKX3ZENF"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Exporta los servicios que usarás
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

